class DynamicFieldsComponent {
  constructor(options = {}) {
    this.wrapperSelector = options.wrapperSelector;
    this.containerSelector = options.containerSelector;
    this.fieldSelector = options.fieldSelector;
    this.addFieldButtonSelector = options.addFieldButtonSelector;
    this.addSeparatorButtonSelector = options.addSeparatorButtonSelector;
    this.addTitleAndDescriptionButtonSelector = options.addTitleAndDescriptionButtonSelector;
    this.fieldTemplateSelector = options.fieldTemplateSelector;
    this.separatorTemplateSelector = options.separatorTemplateSelector;
    this.TitleAndDescriptionTemplateSelector = options.TitleAndDescriptionTemplateSelector;
    this.removeFieldButtonSelector = options.removeFieldButtonSelector;
    this.moveUpFieldButtonSelector = options.moveUpFieldButtonSelector;
    this.moveDownFieldButtonSelector = options.moveDownFieldButtonSelector;
    this.onAddField = options.onAddField;
    this.onRemoveField = options.onRemoveField;
    this.onMoveUpField = options.onMoveUpField;
    this.onMoveDownField = options.onMoveDownField;
    this.placeholderId = options.placeholderId;
    this.elementCounter = 0;
    this._enableInterpolation();
    this._activateFields();
    this._bindEvents();
  }
  _enableInterpolation() {
    $.fn.replaceAttribute = function(attribute, placeholder, value) {
      $(this).find(`[${attribute}*=${placeholder}]`).addBack(`[${attribute}*=${placeholder}]`).each((index, element) => {
        $(element).attr(attribute, $(element).attr(attribute).replace(placeholder, value));
      });
      return this;
    };
    $.fn.template = function(placeholder, value) {
      const $subtemplate = $(this).find("template, .decidim-template");
      if ($subtemplate.length > 0) {
        $subtemplate.html((index, oldHtml) => $(oldHtml).template(placeholder, value)[0].outerHTML);
      }
      const $subtemplateParents = $(this).find("[data-template]");
      if ($subtemplateParents.length > 0) {
        $subtemplateParents.each((_i, elem) => {
          const $self = $(elem);
          const $tpl = $($self.data("template"));
          const $subtpl = $($tpl[0].outerHTML);
          const subtemplateId = `${$tpl.attr("id")}-${value}`;
          const subtemplateSelector = `#${subtemplateId}`;
          $subtpl.attr("id", subtemplateId);
          $self.attr("data-template", subtemplateSelector).data("template", subtemplateSelector);
          $tpl.after($subtpl);
          $subtpl.html((index, oldHtml) => $(oldHtml).template(placeholder, value)[0].outerHTML);
        });
      }
      $(this).replaceAttribute("id", placeholder, value);
      $(this).replaceAttribute("name", placeholder, value);
      $(this).replaceAttribute("data-tabs-content", placeholder, value);
      $(this).replaceAttribute("for", placeholder, value);
      $(this).replaceAttribute("tabs_id", placeholder, value);
      $(this).replaceAttribute("href", placeholder, value);
      $(this).replaceAttribute("value", placeholder, value);
      return this;
    };
  }
  _bindEvents() {
    $(this.wrapperSelector).on(
      "click",
      this.addFieldButtonSelector,
      (event) => this._bindSafeEvent(event, () => this._addField(this.fieldTemplateSelector))
    );
    if (this.addSeparatorButtonSelector) {
      $(this.wrapperSelector).on(
        "click",
        this.addSeparatorButtonSelector,
        (event) => this._bindSafeEvent(event, () => this._addField(this.separatorTemplateSelector))
      );
    }
    if (this.addTitleAndDescriptionButtonSelector) {
      $(this.wrapperSelector).on(
        "click",
        this.addTitleAndDescriptionButtonSelector,
        (event) => this._bindSafeEvent(event, () => this._addField(this.TitleAndDescriptionTemplateSelector))
      );
    }
    $(this.wrapperSelector).on(
      "click",
      this.removeFieldButtonSelector,
      (event) => this._bindSafeEvent(event, (target) => this._removeField(target))
    );
    if (this.moveUpFieldButtonSelector) {
      $(this.wrapperSelector).on(
        "click",
        this.moveUpFieldButtonSelector,
        (event) => this._bindSafeEvent(event, (target) => this._moveUpField(target))
      );
    }
    if (this.moveDownFieldButtonSelector) {
      $(this.wrapperSelector).on(
        "click",
        this.moveDownFieldButtonSelector,
        (event) => this._bindSafeEvent(event, (target) => this._moveDownField(target))
      );
    }
  }
  _bindSafeEvent(event, cb) {
    event.preventDefault();
    event.stopPropagation();
    try {
      return cb(event.target);
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  // Adds a field.
  //
  // template - A String matching the type of the template. Expected to be
  //  either ".decidim-question-template" or ".decidim-separator-template".
  _addField(templateClass = ".decidim-template") {
    const $wrapper = $(this.wrapperSelector);
    const $container = $wrapper.find(this.containerSelector);
    const templateSelector = $wrapper.data("template");
    let $template = null;
    if (templateSelector) {
      $template = $(templateSelector);
    }
    if ($template === null || $template.length < 1) {
      $template = $wrapper.children(`template, ${templateClass}`);
    }
    const $newField = $($template.html()).template(this.placeholderId, this._getUID());
    $newField.find("ul.tabs").attr("data-tabs", true);
    const $lastQuestion = $container.find(this.fieldSelector).last();
    if ($lastQuestion.length > 0) {
      $lastQuestion.after($newField);
    } else {
      $newField.appendTo($container);
    }
    window.initFoundation($newField);
    if (this.onAddField) {
      this.onAddField($newField);
    }
  }
  _removeField(target) {
    const $target = $(target);
    const $removedField = $target.parents(this.fieldSelector);
    const idInput = $removedField.find("input").filter((idx, input) => input.name.match(/id/));
    if (idInput.length > 0) {
      const deletedInput = $removedField.find("input").filter((idx, input) => input.name.match(/delete/));
      if (deletedInput.length > 0) {
        $(deletedInput[0]).val(true);
      }
      $removedField.addClass("hidden");
      $removedField.hide();
    } else {
      $removedField.remove();
    }
    if (this.onRemoveField) {
      this.onRemoveField($removedField);
    }
  }
  _moveUpField(target) {
    const $target = $(target);
    const $movedUpField = $target.parents(this.fieldSelector);
    $movedUpField.prev().before($movedUpField);
    if (this.onMoveUpField) {
      this.onMoveUpField($movedUpField);
    }
  }
  _moveDownField(target) {
    const $target = $(target);
    const $movedDownField = $target.parents(this.fieldSelector);
    $movedDownField.next().after($movedDownField);
    if (this.onMoveDownField) {
      this.onMoveDownField($movedDownField);
    }
  }
  _activateFields() {
    const $wrapper = $(this.wrapperSelector);
    const $container = $wrapper.find(this.containerSelector);
    $container.append($container.find("script"));
    $(this.fieldSelector).each((idx, el) => {
      $(el).template(this.placeholderId, this._getUID());
      $(el).find("ul.tabs").attr("data-tabs", true);
    });
  }
  _getUID() {
    this.elementCounter += 1;
    return (/* @__PURE__ */ new Date()).getTime() + this.elementCounter;
  }
}
export default function createDynamicFields(options) {
  return new DynamicFieldsComponent(options);
}
